import mixpanel, { Callback, Dict, RequestOptions } from 'mixpanel-browser';
import { MixpanelEvents } from 'src/tracking/mixpanel/MixpanelEvents';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';

const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN;
export class Mixpanel {
  static initialise() {
    if (mixpanelToken) {
      mixpanel.init(mixpanelToken, {
        api_host: 'https://api-eu.mixpanel.com',
        track_pageview: false,
        persistence: 'localStorage',
      });
    }
  }

  static getDistinctId() {
    if (mixpanelToken) {
      return mixpanel.get_distinct_id();
    }
  }

  static identify(userId: string) {
    if (mixpanelToken) {
      mixpanel.identify(userId);
    }
  }

  static setPeople(email: string, tenantId: string) {
    if (mixpanelToken) {
      mixpanel.people.set({
        $email: email,
        tenant: tenantId,
      });
    }
  }

  static track(
    event_name: MixpanelEvents,
    properties?: Dict,
    optionsOrCallback?: RequestOptions | Callback,
    callback?: Callback,
  ) {
    if (mixpanelToken) {
      mixpanel.track(event_name, properties, optionsOrCallback, callback);
    }
  }
}

export function dataUploadFileProperties(file: UploadedFile) {
  return {
    dataUploadFileId: file.id,
    dataUploadModel: file.dataUploadModel!.displayName,
    useDataUploadModelId: file.dataUploadModel!.id,
    fileId: file.file.id,
    fileName: file.file.fileName,
    fileType: file.file.fileType,
  };
}
